import { NgModule, PLATFORM_ID } from '@angular/core';

import { WindowService } from '../../shared/services/window.service';
import { ClientStartupConfigService } from '../../shared/shared-context/client-startup-config.service';
import { SERVICE_WORKER_API_AVAILABLE } from '../service-worker-api-available.injection-token';
import { SERVICE_WORKER_USER_ID_FACTORY } from '../service-worker-user-id.injection-token';
import { CRYPTO_API_AVAILABLE } from './crypto-api-available.injection-token';
import { DigestService } from './digest.service';
import { encryptedServiceWorkerApiAvailableFactory } from './encrypted-service-worker-available.factory';
import { saltedHashServiceWorkerUserIdFactory } from './salted-hash-service-worker-user-id.factory';

// Include this module _after_ the ServiceWorkerModule to override Service Worker features with an encryption-based implementation.
@NgModule({
    providers: [
        {
            provide: SERVICE_WORKER_API_AVAILABLE,
            useFactory: encryptedServiceWorkerApiAvailableFactory,
            deps: [WindowService, PLATFORM_ID, CRYPTO_API_AVAILABLE]
        },
        {
            provide: SERVICE_WORKER_USER_ID_FACTORY,
            useFactory: saltedHashServiceWorkerUserIdFactory,
            deps: [ClientStartupConfigService, DigestService]
        }
    ]
})
export class ServicedWorkerEncryptionModule {
}
